/*
 * @Author: shirley 1040698446@qq.com
 * @Date: 2022-10-26 18:17:00
 * @LastEditors: shirley 1040698446@qq.com
 * @LastEditTime: 2023-04-08 14:42:39
 * @FilePath: \front-questionnaire\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import '@/styles/elementTheme/theme/index.css'
import '@/assets/style/flex.css';
// 导入tool方法
import { Tool } from '@/utils/tool';
import { ToolQuestion } from '@/utils/questionnaire';
import './plugin/index';
import './api/index';
import './icons/index'; // icon
Vue.config.productionTip = false;
Vue.prototype.$tool = new Tool();
Vue.prototype.$toolQuestion = new ToolQuestion();
import VueLazyLoad from 'vue-lazyload';
// 使用懒加载插件,loading参数指定加载图片的gif地址,这个gif也要放在static文件夹里
Vue.use(VueLazyLoad, {
  loading: '../assets/img/avatar.png',
});

import pluginExport from '@d2-projects/vue-table-export';
Vue.use(pluginExport);
import myloading from '@/components/myloading/index.js';
Vue.use(myloading);
// import animated from 'animate.css';
// Vue.use(animated)

import VueCodeMirror from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
Vue.use(VueCodeMirror);
// vue virtual scroller
// import "vue-virtual-scroller/dist/vue-virtual-scroller.css" // 引入它的 css
// import VueVirtualScroller from "vue-virtual-scroller" // 引入它
// Vue.use(VueVirtualScroller) // use
import Directives from '@/directive';
Vue.use(Directives);
import InfoDialog from '@/components/infoDialog/index.js';
Vue.use(InfoDialog);
import MediaPreview from '@/components/mediaPreview/index.js';
Vue.use(MediaPreview);
import './registerServiceWorker';

import './utils/validate'; //表单验证

// 根据域名 设置全局变量 globalName和globalName_en
switch (window.location.hostname) {
  case 'www.wenjuanjia.com':
  case 'wenjuanjia.com':
    Vue.prototype.$globalName = '问卷家';
    Vue.prototype.$subName = 'wenjuanjia';
    Vue.prototype.$webSite = 'https://www.wenjuanjia.com';
    Vue.prototype.$coinName = '问卷币';
    break;
  default:
    Vue.prototype.$globalName = '龙艺秀';
    Vue.prototype.$subName = 'longyixiu';
    Vue.prototype.$webSite = 'https://www.longyixiu.com';
    Vue.prototype.$coinName = '龙艺币';
    break;
}

// Vue.prototype.$infoDialog = InfoDialog;
router.beforeEach((to: any, from: any, next: any) => {
  /* 路由发生变化修改页面title */
  if (to.meta) {
    if (to.meta.title === '首页') {
      document.title = Vue.prototype.$globalName + '_免费问卷调查/考试/投票平台';
    } else {
      if (to.meta.title) {
        document.title = to.meta.title + '_' + Vue.prototype.$globalName;
      }
    }
  }
  console.log('iconicon');

  next();
});
new Vue({
  router,
  store,
  render: (h: any) => h(App),
}).$mount('#app');
